// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/partner-economics/PartnerEconomicsEntry"),
  subApps: [
    {
      name: "partner-settlements"
    },
    {
      name: "salary-basis-reports"
    },
    {
      name: "dac7-downloads"
    },
    {
      name: "bank-details"
    }
  ],
  orderPrio: 90,
  iconType: "pie-chart",
  name: "partner-economics"
}: AppType)
